import { RedirectPage } from "components/UI/RedirectPage/RedirectPage";
import { Route as AdvertiserPayoutsRequestsPage } from "routes/_authenticated/$tenantSlug/_layout/advertiser/_layout/request/_layout/entry";
import { Route as AdvertiserEntriesRequestsPage } from "routes/_authenticated/$tenantSlug/_layout/advertiser/_layout/request/_layout/payout";
import { PermissionEnum } from "types/enums";
import { createTenantFileRoute } from "utils/createTenantFileRoute";

export const Route = createTenantFileRoute("/_authenticated/$tenantSlug/_layout/advertiser/_layout/request/")({
    component: AdvertiserRequestsPage,
    staticData: {
        permissions: [PermissionEnum.AdvertiserPayoutView, PermissionEnum.AdvertiserEntryView],
        showInSideMenu: false,
        label: "pages.advertiser.request.title",
        redirects: [AdvertiserEntriesRequestsPage, AdvertiserPayoutsRequestsPage],
        defaultRedirect: AdvertiserEntriesRequestsPage,
    },
    loader: ({ context: { t } }) => ({
        breadcrumb: t("pages.advertiser.request.title"),
    }),
});

function AdvertiserRequestsPage() {
    return <RedirectPage />;
}
